import React, { useState, useEffect, useMemo, useRef, forwardRef } from "react";
import axios from "axios";
import Multiselect from "multiselect-react-dropdown";

const RMultiSelect = forwardRef((props, ref) => {
  return (
    <div className="DropdownHeaderNIMP">
      {props.label}
      <Multiselect
        onRemove={(e, r) => props.onChange(e, r)}
        style={{ searchBox: { minHeight: "15vh" } }}
        onSearch={function noRefCheck() {}}
        displayValue="name"
        groupBy="Group"
        ref={ref}
        placeholder=""
        selectedValues={props.selected}
        avoidHighlightFirstOption="true"
        selectionLimit={props.selectionLimit}
        id="value"
        onSelect={(e, r) => props.onChange(e, r)}
        options={props.options}
        showCheckbox
      />
    </div>
  );
});

// export function Characteristics(props) {
//     const multiselectRef = useRef();
//     const [CharacteristicsOptions, SetCharacteristicsOptions] = useState();
//     const [SelectedOptions, SetSelectedOptions] = useState();
//     const GetCharacteristics = async () => {
//         await axios.get(process.env.REACT_APP_API_BASE_URL +
//             `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=33&ParentLovId=0`,
//             { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
//             .then((res) => {
//                 const Options = res.data.map((item) => ({ name: item.lovName, value: item.lovId, }));
//                 SetCharacteristicsOptions(Options);
//                 const SOptions = Options.filter((item) => props.Selected?.includes(item.value));
//                 SetSelectedOptions(SOptions.length > 0 ? SOptions : [Options?.[0]]);
//                 const SelectedValues = SOptions.map((item) => item.value);
//                 props.StoreOptions(
//                     SelectedValues.length > 0 ? SelectedValues : [Options?.[0]?.value]
//                 );
//             })
//             .catch((err) => { console.log(err); });
//     };
//     useEffect(() => {
//         if (props.SubjectId && props.Preselected === 0) {
//             SetCharacteristicsOptions();
//             GetCharacteristics();
//         }
//     }, [props.Preselected]);
//     return (
//         <RMultiSelect onChange={(e, r) => props.onChange(e, r)}
//             selected={CharacteristicsOptions && SelectedOptions} ref={multiselectRef}
//             options={CharacteristicsOptions} label="Characteristics :" />
//     );
// }

export function Levelone(props) {
  const multiselectRef = useRef();
  const [LeveloneOptions, SetLeveloneOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetLevelone = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/EnglishQuestionBank/GetProcessLevel1ById?SubjectId=${props.SubjectId}&LovCategoryId=33&ParentLovId=0&LanguageId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          name: item.lovName,
          value: item.lovId,
        }));
        SetLeveloneOptions(Options);
        const SOptions = Options.filter((item) =>
          props.Selected?.includes(item.value)
        );
        SetSelectedOptions(SOptions.length > 0 ? SOptions : [Options?.[0]]);
        const SelectedValues = SOptions.map((item) => item.value);
        props.StoreOptions(
          SelectedValues.length > 0 ? SelectedValues : [Options?.[0]?.value]
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.SubjectId && props.Preselected === 0) {
      SetLeveloneOptions();
      GetLevelone();
    }
  }, [props.Preselected]);
  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={LeveloneOptions && SelectedOptions}
      ref={multiselectRef}
      options={LeveloneOptions}
      label="Level 1 :"
    />
  );
}

export function LevelTwo(props) {
  const multiselectRef = useRef();
  const [LevelTwoOptions, SetLevelTwoOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetLevelTwo = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/EnglishQuestionBankByLO/GetLevel2ByLevel1?Level1Id=${props.Pid}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        multiselectRef.current.resetSelectedValues();
        //   props.clear("Stream");
        const Options = res.data.flatMap((element) =>
          element.Value.map((item) => ({
            name: item.LovDescription,
            value: item.LovId,
            Group: item.ParentLovName,
          }))
        );
        const SOptions = Options.filter((item) =>
          props.Preselected?.includes(item.value)
        );
        SetSelectedOptions(SOptions);
        SetLevelTwoOptions(Options);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    props.clear("LevelTwo");
    if (props.Pid) {
      GetLevelTwo();
    } else {
      multiselectRef.current.resetSelectedValues();
      SetLevelTwoOptions();
    }
  }, [props.Pid]);

  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={SelectedOptions}
      ref={multiselectRef}
      options={LevelTwoOptions}
      label="Level 2 :"
    />
  );
}

export function DDGrammer(props) {
  const multiselectRef = useRef();
  const [GrammerOptions, SetGrammerOptions] = useState();
  const [SelectedOptions, SetSelectedOptions] = useState();
  const GetGrammer = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
          `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SubjectId}&LovCategoryId=38&ParentLovId=0&LanguageId=0`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          name: item.lovName,
          value: item.lovId,
        }));
        const AddOptions = [{ name: "All", value: 0 }, ...Options];
        SetGrammerOptions(AddOptions);
        const SOptions = AddOptions.filter((item) =>
          props.Selected?.includes(item.value)
        );
        SetSelectedOptions(SOptions.length > 0 ? SOptions : [Options?.[0]]);
        const SelectedValues = SOptions.map((item) => item.value);
        props.StoreOptions(
          SelectedValues.length > 0 ? SelectedValues : [Options?.[0]?.value]
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useMemo(() => {
    if (props.Selected.includes(0) && GrammerOptions) {
      const SOptions = GrammerOptions.filter((item) =>
        props.Selected?.includes(item.value)
      );
      SetSelectedOptions(
        SOptions.length > 0 ? SOptions : [GrammerOptions?.[1]]
      );
      // const SelectedValues = SOptions.map((item) => item.value);
      //     props.StoreOptions(
      //         SelectedValues.length > 0 ? SelectedValues : [GrammerOptions?.[1]?.value]
      //     );
    } else if (!GrammerOptions) {
      GetGrammer();
    }
  }, [props.Selected]);

  useEffect(() => {
    if (props.SubjectId && props.Preselected === 0) {
      SetGrammerOptions();
      GetGrammer();
    }
  }, [props.Preselected]);
  return (
    <RMultiSelect
      onChange={(e, r) => props.onChange(e, r)}
      selected={GrammerOptions && SelectedOptions}
      ref={multiselectRef}
      options={GrammerOptions}
      label="Grammar :"
      selectionLimit={props.selectionLimit}
    />
    // SelectedOptions.includes("0") ? 1 : -1
  );
}
